import theme from "./theme";
/** @type {import('tailwindcss').Config} */
export default {
  darkMode: ["class"],
  content: ["./src/**/*.{js,jsx,ts,tsx}"],
  safelist: ["bg-slate-100"],
  theme: {
    extend: {
      fontFamily: {
        sans: ["Inter", "ui-sans-serif", "system-ui", "sans-serif"],
        mono: ["Roboto Mono", "monospace"],
      },
      colors: {
        input: "hsl(var(--fb-input))",
        ring: "hsl(var(--fb-ring))",
        background: "hsl(var(--fb-background))",
        foreground: "hsl(var(--fb-foreground))",
        divider: "var(--fb-border)",
        border: {
          DEFAULT: "var(--fb-border)",
          primary: "var(--fb-border-primary)",
          dark: "var(--fb-border-dark)",
          "primary-dark": "var(--fb-primary-dark)",
          "dark-20": "var(--fb-primary-border-dark-20)",
        },
        primary: {
          DEFAULT: "var(--fb-primary)",
          background: "var(--fb-primary-background)",
          foreground: "var(--fb-primary-foreground)",
          border: "var(--fb-primary-border)",
        },
        secondary: {
          DEFAULT: "var(--fb-secondary)",
          foreground: "hsl(var(--fb-secondary-foreground))",
        },
        destructive: {
          DEFAULT: "hsl(var(--fb-destructive))",
          foreground: "hsl(var(--fb-destructive-foreground))",
        },
        muted: {
          DEFAULT: "var(--fb-muted)",
          foreground: "hsl(var(--fb-muted-foreground))",
        },
        accent: {
          DEFAULT: "hsl(var(--fb-accent))",
          foreground: "hsl(var(--fb-accent-foreground))",
        },
        popover: {
          DEFAULT: "hsl(var(--fb-popover))",
          foreground: "hsl(var(--fb-popover-foreground))",
        },
        card: {
          DEFAULT: "hsl(var(--fb-card))",
          foreground: "hsl(var(--fb-card-foreground))",
        },
        // Use the warning definition from the second extend block:
        warning: "hsl(var(--fb-warning))",
        // Spread in any additional colors from your imported theme:
        ...theme.colors,
        // Include the sidebar colors from the first extend block:
        sidebar: {
          DEFAULT: "hsl(var(--fb-sidebar-background))",
          foreground: "hsl(var(--fb-sidebar-foreground))",
          primary: "hsl(var(--fb-sidebar-primary))",
          "primary-foreground": "hsl(var(--fb-sidebar-primary-foreground))",
          accent: "hsl(var(--fb-sidebar-accent))",
          "accent-foreground": "hsl(var(--fb-sidebar-accent-foreground))",
          border: "hsl(var(--fb-sidebar-border))",
          ring: "hsl(var(--fb-sidebar-ring))",
        },
      },
      textColor: {
        primary: "var(--fb-primary-text)",
        "primary-dark": "var(--fb-primary-dark)",
        "primary-accent": "var(--fb-primary)",
        secondary: "var(--fb-secondary-text)",
        disabled: "var(--fb-disabled-text)",
        label: "#4E5B6F",
        inverse: "var(--fb-text-inverse)",
        "secondary-variant": "var(--fb-secondary)",
        // Merged in from the second extend block:
        warning: "var(--fb-warning-text)",
      },
      backgroundColor: {
        palette: {
          DEFAULT: "var(--fb-background-default)",
          neutral: "var(--fb-background-neutral)",
          inverse: "var(--fb-background-inverse)",
        },
        contrast: "#F3F4F6",
        accent: "#F4F4F5",
        secondary: "var(--fb-disabled-text)",
      },
      width: {
        25: "6.25rem",
        30: "7.5rem",
        75: "18.75rem",
        98: "24.5rem",
        100: "25rem",
      },
      leading: {
        4.5: "1.125rem",
      },
      borderRadius: {
        1: "0.25rem",
      },
      boxShadow: {
        node: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
        nodeHover: "0px 10px 20px 40px rgba(0, 0, 0, 0.05)",
        "toast-icon-green": "0px 0px 16px 0px #2FC362",
        "soft-sm": "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
        "light-sm": "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px",
      },
      spacing: {
        0.5: "0.125rem",
        1.5: "0.375rem",
        3.5: "0.875rem",
        4.5: "1.125rem",
        9.5: "2.375rem",
        17: "4.25rem",
        18: "4.5rem",
        85: "21.25rem",
        90: "22.5rem",
        110: "27.5rem",
        120: "30rem",
        160: "40rem",
        200: "50rem",
        250: "62.5rem",
        280: "70rem",
      },
      keyframes: {
        "accordion-down": {
          from: {height: "0"},
          to: {height: "var(--radix-accordion-content-height)"},
        },
        "accordion-up": {
          from: {height: "var(--radix-accordion-content-height)"},
          to: {height: "0"},
        },
        "highlight-text": {
          "0%, 100%": {backgroundColor: "transparent"},
          "50%": {backgroundColor: "#fcd34d"},
        },
        pulseSize: {
          "0%, 100%": {transform: "scale(1)"},
          "50%": {transform: "scale(1.14)"},
        },
        redPulse: {
          "0%, 50%": {opacity: 0, transform: "scale(1)"}, // Stay hidden
          "70%": {opacity: 0.3, transform: "scale(1.3)"}, // Quick peak
          "100%": {opacity: 0, transform: "scale(1.6)"},
        },
      },
      animation: {
        "accordion-down": "accordion-down 0.2s ease-out",
        "accordion-up": "accordion-up 0.2s ease-out",
        "highlight-text": "highlight-text 0.5s ease-in-out 2",
        pulseSize: "pulseSize 1.2s infinite ease-in-out",
        redPulse: "redPulse 1.2s infinite ease-out",
      },
      opacity: {
        8: "0.08",
        10: "0.1",
        20: "0.2",
        12: "0.12",
        16: "0.16",
      },
      zIndex: {
        1000: "1000",
      },
      borderWidth: {
        6: "6px",
      },
    },
  },
  plugins: [require("tailwindcss-animate")],
};
